"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocationAwarePurchaseMotionData = exports.getPurchaseMotionData = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _AuthStates = require("self-service-api/constants/AuthStates");

var _purchaseMotionApi = require("self-service-api/core/api/purchaseMotionApi");

var _validators = require("self-service-api/core/validators");

var _productsAdapter = _interopRequireDefault(require("self-service-api/adapters/productsAdapter"));

var _availableTrialsAdapter = _interopRequireDefault(require("self-service-api/adapters/availableTrialsAdapter"));

var _adaptPurchaseMotionResponse = function _adaptPurchaseMotionResponse(purchaseMotionMetaData) {
  var availableTrials = purchaseMotionMetaData.availableTrials,
      customerCurrencyCode = purchaseMotionMetaData.customerCurrencyCode,
      productCatalog = purchaseMotionMetaData.productCatalog,
      productBasedOffers = purchaseMotionMetaData.productBasedOffers,
      parcels = purchaseMotionMetaData.parcels,
      subscriptionTerms = purchaseMotionMetaData.subscriptionTerms;
  return {
    authState: _AuthStates.AUTHED,
    availableTrials: (0, _availableTrialsAdapter.default)(availableTrials),
    customerCurrencyCode: customerCurrencyCode,
    productCatalog: (0, _productsAdapter.default)({
      productCatalog: productCatalog,
      customerCurrencyCode: customerCurrencyCode
    }).products,
    productBasedOffers: productBasedOffers,
    parcels: parcels,
    subscriptionTerms: subscriptionTerms
  };
};

var getPurchaseMotionData = function getPurchaseMotionData() {
  var merchandiseIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  merchandiseIds.forEach(_validators.validateMerchandiseId);
  return (0, _purchaseMotionApi.fetchPurchaseMotionData)(merchandiseIds).then(function (purchaseMotionData) {
    return (0, _extends2.default)({}, _adaptPurchaseMotionResponse(purchaseMotionData), {
      purchaseMotions: purchaseMotionData.purchaseMotions
    });
  });
};

exports.getPurchaseMotionData = getPurchaseMotionData;

var getLocationAwarePurchaseMotionData = function getLocationAwarePurchaseMotionData(_ref) {
  var merchandiseIds = _ref.merchandiseIds,
      locations = _ref.locations,
      apiGetter = _ref.apiGetter;

  if (!locations || locations.length === 0) {
    throw new Error('Need to specify location');
  }

  if (!merchandiseIds) {
    merchandiseIds = [];
  }

  merchandiseIds.forEach(_validators.validateMerchandiseId);
  return (0, _purchaseMotionApi.fetchLocationAwarePurchaseMotionData)({
    merchandiseIds: merchandiseIds,
    locations: locations,
    apiGetter: apiGetter
  }).then(function (response) {
    return (0, _extends2.default)({}, response, {
      metadata: _adaptPurchaseMotionResponse(response.metadata)
    });
  });
};

exports.getLocationAwarePurchaseMotionData = getLocationAwarePurchaseMotionData;